import * as types from "./types";

const initialState = {
  menus: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_MENUS: {
      return {
        ...state,
        menus: action?.payload?.data?.data,
      };
    }
    default:
      return state;
  }
};

export default reducer;
